import React from "react";
import { Box, CircularProgress, Typography } from "@material-ui/core";
import AppBar from "@material-ui/core/AppBar";
import { TOOLBAR_OFFSET } from "styles/utils";
import { LanguageSelection } from "./LanguageSelection";
import { matchPath, useLocation } from "react-router-dom";
import { routes } from "pages/routes";
import { useAdminPanel } from "components/AdminPanel/hooks";
import { useSelector } from "react-redux";
import { isIFrame } from "utils";
import { useCustomFrame } from "hooks/api";
import Iframe from "react-iframe";
import { API } from "api";
import { LoaderContainer } from "components";
import { getUserName } from "store/features/materialSpecs/specs";

interface TopPanelProps {
    matSpecId: number;
}

export const TopPanel: React.FC<TopPanelProps> = ({ matSpecId }) => {
    const userName = useSelector(getUserName);
    const location = useLocation();
    const isVisible = useAdminPanel();
    // TODO: remove this when campaign view will be moved to separate repository and briefing form will be merged
    const currentRoute = routes.find((route) => matchPath(location.pathname, route));
    const { data, isFetching } = useCustomFrame("header", matSpecId, undefined, false);

    if (isVisible || currentRoute?.key === "briefingForm" || isIFrame) {
        return null;
    }

    return (
        <AppBar
            position="fixed"
            // TODO: move to separate component when top bar looks will be clarified
            style={{
                height: `${TOOLBAR_OFFSET}px`,
                flexDirection: "column",
            }}>
            <Box flex={1} display="flex" height={TOOLBAR_OFFSET} justifyContent="space-between" bgcolor="white">
                {isFetching ? (
                    <Box position="relative" width="100%" height="100%">
                        <LoaderContainer>
                            <CircularProgress />
                        </LoaderContainer>
                    </Box>
                ) : (
                    <Iframe
                        url={`${API.serverUrl}${data?.url}`}
                        frameBorder={0}
                        width="100%"
                        height="100%"
                        position="relative"
                    />
                )}

                <Box p={1} display="flex" alignItems="flex-end" justifyContent="center" flexDirection="column">
                    {userName && (
                        <Typography variant="body2" component="div" color="textPrimary">
                            <Box pr={2} fontWeight="fontWeightMedium">
                                {userName.toUpperCase()}
                            </Box>
                        </Typography>
                    )}
                    <LanguageSelection />
                </Box>
            </Box>
        </AppBar>
    );
};
